/**
 * Infinite Scroll for Collection Pages
 * Auto-loads next page of products when scrolling near bottom
 */
(function() {
  var loading = false;
  var noMore = false;
  var grid = document.getElementById('product-grid');
  var pagination = document.querySelector('.pagination');

  if (!grid) return;

  // Find next page link
  function getNextUrl() {
    var next = document.querySelector('.pagination__item--prev + .pagination__item a, .pagination .pagination__item:last-child a');
    // More reliable: look for the "next" arrow link
    var arrows = document.querySelectorAll('.pagination__item--next a, .pagination a[rel="next"]');
    if (arrows.length > 0) return arrows[0].href;

    // Fallback: find any pagination link with a higher page number
    var current = document.querySelector('.pagination__item.pagination__item--current, .pagination__item aria-current');
    var links = document.querySelectorAll('.pagination a');
    var found = false;
    for (var i = 0; i < links.length; i++) {
      if (found) return links[i].href;
      if (links[i].getAttribute('aria-current') === 'page') found = true;
    }
    return null;
  }

  // Hide pagination
  if (pagination) {
    pagination.style.display = 'none';
  }
  // Also hide any other pagination wrappers
  document.querySelectorAll('.pagination-wrapper, .pagination').forEach(function(el) {
    el.style.display = 'none';
  });

  // Create loading indicator
  var loader = document.createElement('div');
  loader.setAttribute('style',
    'text-align:center;padding:2rem 0;display:none;'
  );
  loader.innerHTML = '<span style="font-size:0.85rem;color:#999;letter-spacing:0.05em;">Loading more...</span>';
  grid.parentNode.insertBefore(loader, grid.nextSibling);

  // Scroll listener
  function onScroll() {
    if (loading || noMore) return;

    var scrollBottom = window.innerHeight + window.scrollY;
    var pageBottom = document.documentElement.scrollHeight - 800;

    if (scrollBottom >= pageBottom) {
      loadNext();
    }
  }

  function loadNext() {
    var nextUrl = getNextUrl();
    if (!nextUrl) {
      noMore = true;
      return;
    }

    loading = true;
    loader.style.display = 'block';

    fetch(nextUrl)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Get new product items
        var newGrid = doc.getElementById('product-grid');
        if (newGrid) {
          var items = newGrid.querySelectorAll('.grid__item');
          items.forEach(function(item) {
            grid.appendChild(item);
          });
        }

        // Update pagination HTML for next page detection
        var newPagination = doc.querySelector('.pagination');
        if (pagination && newPagination) {
          pagination.innerHTML = newPagination.innerHTML;
        } else if (newPagination) {
          pagination = newPagination;
          document.body.appendChild(pagination);
          pagination.style.display = 'none';
        }

        // Check if there are more pages
        var nextNext = null;
        var arrows = doc.querySelectorAll('.pagination__item--next a, .pagination a[rel="next"]');
        if (arrows.length > 0) {
          nextNext = arrows[0].href;
        } else {
          // Fallback check
          var docLinks = doc.querySelectorAll('.pagination a');
          var docFound = false;
          for (var i = 0; i < docLinks.length; i++) {
            if (docFound) { nextNext = docLinks[i].href; break; }
            if (docLinks[i].getAttribute('aria-current') === 'page') docFound = true;
          }
        }

        if (!nextNext) {
          noMore = true;
        }

        // Re-init any size button listeners (they use event delegation, so they work automatically)
        // Re-init badges for newly loaded products
        if (typeof window.refreshBadges === 'function') {
          window.refreshBadges();
        }

        loading = false;
        loader.style.display = 'none';
      })
      .catch(function(err) {
        console.error('Infinite scroll error:', err);
        loading = false;
        loader.style.display = 'none';
      });
  }

  window.addEventListener('scroll', onScroll, { passive: true });

})();
